import React from "react";
// nodejs library that concatenates classes
import classNames from "classnames";
// @mui/icons-material
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import Quote from "components/Typography/Quote.js";
// core components
import Button from "components/CustomButtons/Button.js";
import FormatAlignLeft from "@mui/icons-material/FormatAlignLeft";
import Card from "components/Card/Card.js";
import CardBody from "components/Card/CardBody.js";
import Tooltip from "@mui/material/Tooltip";
import CardMedia from '@mui/material/CardMedia';
import CardActionArea from "@mui/material/CardActionArea";
import CardActions from "@mui/material/CardActions";
import CardContent from "@mui/material/CardContent";
import Typography from "@mui/material/Typography";
import styles from "../ServicesSections.module.scss";



export default function SectionText() {
  const classes = styles;
  const imgClasses = classNames(
    classes.imgRaised,
    classes.imgRounded,
    classes.imgFluid
  );
  return (
    <div className={classes.section}>
      <GridContainer justifyContent="center">
      <GridItem xs={12} sm={8} md={8}>
      <h3 className={classes.title}>
          Examples of our Google Data Studio Consultancy Work:
          </h3>

          </GridItem>
      <GridItem xs={12} sm={10} md={10} className={classes.section} style={{paddingTop:"10px"}}>

        
        <GridContainer > 
          
        <GridItem xs={12} sm={6} md={6}>
            <Card
              raised
              //background
              //style={{
              //  backgroundImage: "url('/img/sections/services/google-analytics-training/1.webp')",
              //}}
            >
              
              <CardActionArea>
                <CardMedia
                  component="iframe"
                  alt="Contemplative Reptile"
                  //className={classes.media}
                  height="340"
                  image="https://datastudio.google.com/embed/reporting/878d139c-25b5-41b0-846b-ef6603d82e60/page/48mXB"
                  //title="Contemplative Reptile"
                />
                <CardContent>
                
                <Typography variant="subtitle1">SEO - SERP POSITION BY BAND DASHBOARD - DOWNLOADABLE TEMPLATE</Typography>
                <Typography variant="caption">
                This clever SEO dashboard allows you to circumvent the dreaded "cant mix metrics and dimensions in case statements" issue by making use of the Extract Data function in data studio, applying this to search console and then applying the transformations to the resultant data. The result is an awesome data set that splits down your Keywords by Position band - eg 1-5, 5-10 etc.
                </Typography>

                </CardContent>
              </CardActionArea>
            </Card>         
          </GridItem>

          <GridItem xs={12} sm={6} md={6}>
            <Card
              raised
              //background
              //style={{
              //  backgroundImage: "url('/img/sections/services/google-analytics-training/1.webp')",
              //}}
            >
              
              <CardActionArea>
                <CardMedia
                  component="img"
                  //alt="Contemplative Reptile"
                  //className={classes.media}
                  height="340"
                  image="/img/sections/services/data-studio-services/2.webp"
                  //image="/img/sections/services/google-analytics-training/1.webp"
                  title="Contemplative Reptile"
                />
                <CardContent>
                
                <Typography variant="subtitle1">COVID-19 SYMPTOMS DASHBOARD - USING ADWORDS SEARCH DATA</Typography>
                <Typography variant="caption">
                In light of COVID, we created a dashboard that predicts COVID outbreaks. It uses Adwords search data on well known COVID symptoms such as "loss of smell". For more information on what we did here - check out our <a href="/blog-post/2020/07/covid-search-data">blog post</a> Side note! Interestingly - you cant embed Data Studio dashboards that have the new Google maps functionality in them. You just cant :-( Hence we have used an image link above 😀
                </Typography>

                </CardContent>
              </CardActionArea>
            </Card>         
          </GridItem>
          <GridItem xs={12} sm={6} md={6}>
            <Card
              raised
              //background
              //style={{
              //  backgroundImage: "url('/img/sections/services/google-analytics-training/1.webp')",
              //}}
            >
              
              <CardActionArea>
                <CardMedia
                  component="img"
                  //alt="Contemplative Reptile"
                  //className={classes.media}
                  height="340"
                  image="/img/sections/services/data-studio-services/3.webp"
                  //image="/img/sections/services/google-analytics-training/1.webp"
                  title="Contemplative Reptile"
                />
                <CardContent>
                
                <Typography variant="subtitle1">STORE OWNERS (SALES DATA)</Typography>
                <Typography variant="caption">
                Here is an example of mixing offline sales data and online marketing data. We achieve this by storing/blending data sources in Google Cloud Storage and BigQuery. Sales files are automatically captured and moved from gmail using Google Apps scripts. Finally sending the information off to Google Data for easy executive level reporting

                </Typography>

                </CardContent>
              </CardActionArea>
            </Card>         
          </GridItem>
          <GridItem xs={12} sm={6} md={6}>
            <Card
              raised
              //background
              //style={{
              //  backgroundImage: "url('/img/sections/services/google-analytics-training/1.webp')",
              //}}
            >
              
              <CardActionArea>
                <CardMedia
                  component="img"
                  //alt="Contemplative Reptile"
                  //className={classes.media}
                  height="340"
                  image="/img/sections/services/data-studio-services/4.webp"
                  //image="/img/sections/services/google-analytics-training/1.webp"
                  title="Contemplative Reptile"
                />
                <CardContent>
                
                <Typography variant="subtitle1">PUBLISHERS & BLOGGERS EXAMPLE TEMPLATE</Typography>
                <Typography variant="caption">
                Publishers are under increasing scrutiny to show the value of their audience. Advertisers want to see the detail of what they are investing their dollars in! The above is a scaled down version of a publisher dashboard we have built that can help you grow Affiliate & Ad revenue, increase blog traffic & understand your audience.
                </Typography>

                </CardContent>
              </CardActionArea>
            </Card>         
          </GridItem>
          
        </GridContainer>
      </GridItem>
        <GridItem xs={12} sm={8} md={8}>
        <a className={classes.anchor} id="start"></a>
          <h3 className={classes.title}>
          Google Data Studio Consultancy Services - Introduction
          </h3>

          <p> 
          A Google Data Studio consultancy can give you the skills and experience you need to turbo charge your reporting efforts. Training up and retaining staff in the dashboarding field is not easy and mistakes can be costly. Let us partner with your company to get things moving in the right direction - including training up your internal teams! 
          <br /><br />
         
         Tribalism is one of the most innovative Google Data Studio consultanices in Australia. With offices in Melbourne and Sydney our background is steeped in mathematics and the web.
         </p>
          <p> 
 
          <a href="https://datastudio.google.com/">Google Data Studio</a> is a free Data visualization tool that connects natively to the Google stack. This includes a very large group of google tools, eg Search Console, Google Analytics, Google Adwords, BigQery etc see image below. Data studio is our preferred data visualization tool – for most reports (except very large ones).
          
            
            </p> 

          </GridItem>

          <div style={{textAlign: "center",maxWidth:"700px",width:"100%"}}>
            <GridItem xs={12} sm={12} md={12}>     
                  <img
                    src="/img/sections/services/data-studio-services/1.webp"
                    alt="..."
                    className={imgClasses}
                  />
                  
                  <p><br></br><i>The Native Data Studio Connectors and 256! (as at Sep 2020) partner connectors</i></p>
            </GridItem>
        </div>

          <GridItem xs={12} sm={8} md={8}>
          <br /> <br /> 
          <p>It works particularly well connecting to the Google stack. We are one of the few Melbourne & Sydney based consultancies/agencies working across the cutting edge of Data Studio. In the connector image below you will see there are 18 native google connectors but a whopping 256 partner connectors (as of September 2020). There is an entire community of Data Studio developers developing various connectors to the platform which are really taking out of the “free tool” realm into enterprise worthy reporting tool.</p>
          <p>Note: we also work with various other data visualization tools as well including Tableau, Power BI and Infogram.</p>

          </GridItem>

          
          <GridItem xs={12} sm={8} md={8}>
          <h3 className={classes.title}>
          Work with us!
          </h3>
          <p> 
 
          
          Data is hard to understand for anyone if its just presented in tables or text files. If you are interested in develeloping some awesome dashboards but lacking a little expertise, we can help! 
          <br /><br />
          For as little as $2000+gst we can have one of our awesome <a href="/team">dashboard consultants</a>  work with you to turn out an awesome and useful data studio dashboard connected to your particular data assets, in no time. 😀
          <br /><br />
          Get in touch via the form below.  
            </p> 

          </GridItem>

          
      </GridContainer>
    </div>
  );
}
